import React, { useState } from 'react'
import Style from './materialpoptable.module.scss'
import { Table, Button } from 'antd'

export interface tableParam {
  code: string
  name: string
  id: string
  brandIsSale?: string
  [x: string]: any
}
export interface tableresultData {
  current: number // 当前页
  total: number // 总条数
  data: tableParam[]
}
interface Props {
  dataSource: tableresultData // 数据
  loading?: boolean // 加载中
  onClickRow?: (e: tableParam) => void // 选中行
  onChangePage?: (page: number, pageSize?: number) => void // 分页操作
  otherCol?: { title: string; dataIndex: string }[]
  onChange?: (e: any[]) => void
  setBrandList: any[]
  saveChange?: (e: any[]) => void
  but?: boolean
}

// 物料详情筛选弹窗
const MaterialPopTable = (props: Props) => {
  const {
    dataSource,
    loading,
    onClickRow,
    onChangePage,
    onChange,
    saveChange,
    but,
  } = props
  const [chackList, setchackList] = useState<any[]>([])
  // 勾选品牌
  const onChangeMod = (selectedRowKeys: React.Key[], selectedRows: any[]) => {
    onChange && onChange(selectedRows)
    setchackList(selectedRows)
  }
  const setData = () => {
    if (saveChange) {
      saveChange(chackList)
    }
  }
  return (
    <div>
      <Table
        rowKey="brandId"
        tableLayout="fixed"
        className={Style['table-box']}
        size="small"
        dataSource={dataSource.data}
        loading={loading}
        onRow={(record) => ({
          className: Style['table-row'],
          onClick: () =>
            onClickRow && record.click !== false
              ? onClickRow(record)
              : undefined,
        })}
        pagination={{
          size: 'small',
          showTotal: (text) => `${text}条数据`,
          showSizeChanger: false,
          defaultPageSize: 10,
          total: dataSource.total,
          current: dataSource.current,
          onChange: onChangePage,
        }}
        rowSelection={{
          type: 'checkbox',
          onChange: onChangeMod,
        }}
      >
        <Table.Column
          ellipsis
          align="center"
          onHeaderCell={() => ({
            className: Style['table-header'],
          })}
          onCell={() => ({
            className: Style['table-td'],
          })}
          title="名称"
          dataIndex="brandCnName"
          render={(value: any, record: any) => `${value}/${record.brandEnName}`}
        />
      </Table>
      {but ? (
        <div
          style={{
            width: '100%',
            height: '40px',
            paddingTop: '10px',
            position: 'absolute',
            left: 0,
            bottom: 0,
          }}
        >
          <Button className={Style.tablebtn} onClick={setData}>
            确定
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default MaterialPopTable

// 过滤调用的接口数据-本地处理
export const filterData = (
  params: (tableParam & { [x: string]: any })[],
  filterStr?: string,
  page?: string,
): tableresultData => {
  const value = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item.name.toLowerCase().indexOf(value) >= 0 ||
      item.code.toLowerCase().indexOf(value) >= 0,
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
import React, { useState } from 'react'
import Style from './materialpoptable.module.scss'
import { Table, Button } from 'antd'

export interface tableParam {
  code: string
  name: string
  id: string
  brandIsSale?: string
  [x: string]: any
}
export interface tableresultData {
  current: number // 当前页
  total: number // 总条数
  data: tableParam[]
}
interface Props {
  dataSource: tableresultData // 数据
  loading?: boolean // 加载中
  onClickRow?: (e: tableParam) => void // 选中行
  onChangePage?: (page: number, pageSize?: number) => void // 分页操作
  otherCol?: { title: string; dataIndex: string }[]
  onChange?: (e: any[]) => void
  setBrandList: any[]
  saveChange?: (e: any[]) => void
  but?: boolean
}

// 物料详情筛选弹窗
const MaterialPopTable = (props: Props) => {
  const {
    dataSource,
    loading,
    onClickRow,
    onChangePage,
    onChange,
    saveChange,
    but,
  } = props
  const [chackList, setchackList] = useState<any[]>([])
  // 勾选品牌
  const onChangeMod = (selectedRowKeys: React.Key[], selectedRows: any[]) => {
    onChange && onChange(selectedRows)
    setchackList(selectedRows)
  }
  const setData = () => {
    if (saveChange) {
      saveChange(chackList)
    }
  }
  return (
    <div>
      <Table
        rowKey="brandId"
        tableLayout="fixed"
        className={Style['table-box']}
        size="small"
        dataSource={dataSource.data}
        loading={loading}
        onRow={(record) => ({
          className: Style['table-row'],
          onClick: () =>
            onClickRow && record.click !== false
              ? onClickRow(record)
              : undefined,
        })}
        pagination={{
          size: 'small',
          showTotal: (text) => `${text}条数据`,
          showSizeChanger: false,
          defaultPageSize: 10,
          total: dataSource.total,
          current: dataSource.current,
          onChange: onChangePage,
        }}
        rowSelection={{
          type: 'checkbox',
          onChange: onChangeMod,
        }}
      >
        <Table.Column
          ellipsis
          align="center"
          onHeaderCell={() => ({
            className: Style['table-header'],
          })}
          onCell={() => ({
            className: Style['table-td'],
          })}
          title="名称"
          dataIndex="brandCnName"
          render={(value: any, record: any) => `${value}/${record.brandEnName}`}
        />
      </Table>
      {but ? (
        <div
          style={{
            width: '100%',
            height: '40px',
            paddingTop: '10px',
            position: 'absolute',
            left: 0,
            bottom: 0,
          }}
        >
          <Button className={Style.tablebtn} onClick={setData}>
            确定
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default MaterialPopTable

// 过滤调用的接口数据-本地处理
export const filterData = (
  params: (tableParam & { [x: string]: any })[],
  filterStr?: string,
  page?: string,
): tableresultData => {
  const value = filterStr ? filterStr.toLowerCase() : ''
  const arr = params.filter(
    (item: { name: string; code: string }) =>
      item.name.toLowerCase().indexOf(value) >= 0 ||
      item.code.toLowerCase().indexOf(value) >= 0,
  )
  const p = page ? Number.parseInt(page) : 1
  const startidnex = (p - 1) * 10
  const endindex = p * 10
  const slicedata = arr.slice(startidnex, endindex)
  if (page) {
    return {
      current: p,
      total: arr.length,
      data: slicedata,
    }
  }
  return {
    current: p,
    total: arr.length,
    data: arr,
  }
}
